export default "__VITE_ASSET__L7qw567___"